import { combineReducers, configureStore } from '@reduxjs/toolkit';
//sagas
import createSagaMiddleware from '@redux-saga/core';
import rootSaga from 'store/rootSaga';
import { staticReducers } from './staticReducers';
import ReduxInjector from './ReduxInjector';

const devTools = import.meta.env.VITE_ENV !== 'production' ? { trace: true, traceLimit: 25 } : false;

export let store = {};
export const setupStore = (preloadedState) => {
    let sagaMiddleware = createSagaMiddleware();
    const middleware = [sagaMiddleware];
    store = configureStore({
        reducer: { ...staticReducers },
        devTools,
        ...(preloadedState && { preloadedState }),
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                serializableCheck: {
                    ignoredActions: [
                        'employee/submitFormFailed',
                        'employee/submitFormStart',
                        'peopleAuthorizedList/submitFormStart',
                        'peopleAuthorizedList/addPerson',
                        'peopleAuthorizedList/addAuthorizedPerson',
                        'companyAuthorizedList/addItemToAuthorizedList',
                        'organizationList/addItemToMasterList',
                        'organizationList/submitFormStart',
                        'monitoringObjectList/submitFormStart',
                        'divisionList/addItemToAuthorizedList',
                        'divisionList/addItemToMasterList',
                        'locationList/submitFormStart',
                        'relays/submitFormStart',
                    ],
                },
            }).concat(middleware),
    });

    store.injector = new ReduxInjector(store, sagaMiddleware, staticReducers, rootSaga);
    return store;
};
